import Card from 'components/card';
import { useDropzone } from 'react-dropzone';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { MdImage } from 'react-icons/md';
import 'react-lazy-load-image-component/src/effects/blur.css';
import clsx from 'clsx';

const ImagenPreviewEdit = ({ url, currentImagen, prop, onChange, label }) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: {
            'image/*': ['.png', '.jpeg', '.webp']
        },
        onDrop: acceptedFiles => {
            const event = {
                target: {
                    name: prop,
                    files: acceptedFiles
                }
            };
            onChange(event);
        }
    });

    return (
        <div className="w-full md:w-7/12 mb-3">
            <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
                {label}
            </label>

            <Card className="grid w-full grid-cols-1 md:grid-cols-3 gap-3 rounded-[20px] bg-white bg-clip-border p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-900 dark:shadow-none font-dm">

                {/* Dropzone */}
                <div
                    {...getRootProps()}
                    className={clsx(
                        'flex flex-col items-center justify-center w-full h-44 rounded-xl cursor-pointer transition-colors duration-200',
                        'bg-lightPrimary dark:bg-navy-800',
                        isDragActive ? 'border-2 border-dashed border-brand-500 bg-brand-50 dark:bg-brand-400/10' : 'hover:bg-navy-50 dark:hover:bg-navy-700'
                    )}
                >
                    <input {...getInputProps()} name={prop} />
                    <MdImage className="text-[90px] text-brand-500 dark:text-white" />
                    <p className="text-sm text-neutral-900 dark:text-neutral-200 p-3">
                        <span className="font-semibold">Haz clic o arrastra para subir imagen</span>
                    </p>
                    <p className="text-xs text-neutral-900 dark:text-neutral-200">WEBP, PNG & JPEG</p>
                </div>

                {/* Imagen actual */}
                <div className="flex flex-col items-center justify-center w-full h-44 rounded-xl bg-lightPrimary dark:bg-navy-800">
                    <label className="text-navy-700 dark:text-white mb-2">Imagen actual</label>
                    {currentImagen && (
                        <LazyLoadImage
                            className="object-cover w-32 h-32 rounded-xl"
                            alt="Imagen actual"
                            effect="black-and-white"
                            src={`/images/productos/${currentImagen}`}
                        />
                    )}
                </div>

                {/* Nueva imagen */}
                <div className="flex flex-col items-center justify-center w-full h-44 rounded-xl bg-lightPrimary dark:bg-navy-800">
                    <label className="text-navy-700 dark:text-white mb-2">Nueva imagen</label>
                    {url && (
                        <LazyLoadImage
                            className="object-cover w-32 h-32 rounded-xl"
                            alt="Nueva imagen"
                            effect="black-and-white"
                            src={url}
                        />
                    )}
                </div>
            </Card>
        </div>
    );
};

export default ImagenPreviewEdit;
